export default __webpack_public_path__ + "ef06278028ca5cea80eb95863009bfb2.png";